import { Select, SelectProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { QcsDropdownListSubheader } from './QcsDropdownListSubheader';
import { QcsDropdownMenuItem } from './QcsDropdownMenuItem';

export type QcsDropdownItem<T = unknown> =
  | {
      isSubheader: true;
      label: ReactNode;
      key?: string | number;
    }
  | {
      isSubheader?: false;
      value: T;
      label: ReactNode;
      disabled?: boolean;
      grouped?: boolean;
      key?: string | number;
    };

type Props<T> = Omit<SelectProps<T>, 'children'> & {
  items: QcsDropdownItem<T>[];
};

export function QcsDropdownMenu<T>({ items, ...selectProps }: Props<T>): ReactElement {
  const firstSubheaderIdx = items.findIndex((item) => item.isSubheader);

  return (
    <Select {...selectProps}>
      {items.map((item, idx) => {
        if (item.isSubheader) {
          return (
            <QcsDropdownListSubheader key={item.key ?? `subheader-${idx}`} isFirst={idx === firstSubheaderIdx}>
              {item.label}
            </QcsDropdownListSubheader>
          );
        }
        const inGroup = firstSubheaderIdx !== -1 && idx > firstSubheaderIdx;
        return (
          <QcsDropdownMenuItem key={item.key ?? `item-${idx}`} value={item.value} disabled={item.disabled} grouped={item.grouped ?? inGroup}>
            {item.label}
          </QcsDropdownMenuItem>
        );
      })}
    </Select>
  );
}
